import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Toaster } from "react-hot-toast";
import SearchIcon from "@mui/icons-material/Search";
import {
  getDealerDirectory,
  getDealerDirectoryData,
} from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import styles from "./DealerDirectoryList.module.css";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import moment from "moment";

const messageStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100vh",
  width: "75%",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const DealerDirectoryList = ({ onSelectDealer }) => {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [clubCategory, setClubCategory] = useState([]);
  const [dealerType, setDealerType] = useState([]);
  const [selectedClub, setSelectedClub] = useState("");
  const [selectedDealerType, setSelectedDealerType] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalSums, setTotalSums] = useState();

  const [compareData, setCompareData] = useState([]);

  const handleChange = (e) => {
    setSearch(e.target.value);
  };

  useEffect(async () => {
    await getDealerDirectory({
      currentPage,
      search,
      selectedClub,
      selectedDealerType,
    })
      .then((d) => {
        setClubCategory(d?.clubs?.filter((element) => element !== ""));

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toastMessage("error fetching data", "error");
      });
  }, []);

  useEffect(async () => {
    await getDealerDirectoryData({
      currentPage,
      search,
      selectedClub,
      selectedDealerType,
    })
      .then((d) => {
        setData(d?.data);
        setTotalPages(d?.totalPage);
        setTotalSums(d?.totalSum);
        setDealerType(
          d?.distinctDealerTypes?.filter((element) => element !== "")
        );
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toastMessage("error fetching data", "error");
      });
  }, [currentPage, search, selectedClub, selectedDealerType]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const updateCompareList = async (data) => {
    const isDataInArray = compareData.find((item) => item._id === data._id);
    if (!isDataInArray) {
      if (compareData.length < 3) {
        setCompareData((prevData) => [...prevData, data]);
      } else {
        toastMessage("You can select upto 3 dealers only !", "error");
      }
    } else {
      const updatedCompareData = compareData.filter(
        (item) => item._id !== data._id
      );
      setCompareData(updatedCompareData);
    }
  };

  const handleRowClick = (selectedData) => {
    onSelectDealer(selectedData);
  };

  const formatNumber = (number) => {
    console.log("number", number);
    let numberString = String(Math.abs(number));
    let groups = [];
    while (numberString.length > 0) {
      groups.unshift(numberString.slice(-3));
      numberString = numberString.slice(0, -3);
    }
    return (number < 0 ? "-" : "") + groups.join(",");
  };

  const calculatePercentage = (current, lastMonth) => {
    console.log("curre", current, lastMonth);
    const percentage =
      isFinite(lastMonth) && lastMonth !== 0
        ? ((current - lastMonth) / lastMonth) * 100
        : 0;
    return isFinite(percentage) && !isNaN(percentage)
      ? percentage.toFixed(2)
      : 0;
  };

  useEffect(() => {
    setCompareData([]);
  }, [selectedClub, selectedDealerType]);

  console.log("compare", totalSums?.totalOutTotal);

  return (
    <>
      <div>
        <p
          style={{
            font: "25px",
            fontWeight: "bolder",
            color: "darkgrey",
          }}
        >
          Dealer Directory
        </p>
      </div>
      <div
        style={{
          width: "98%",
          border: "1.5px solid grey",
          marginBottom: "1rem",
        }}
      />
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <FormControl sx={{ m: 1, minWidth: 150 }} size="small">
            <InputLabel id="zone-label">Filter by Club</InputLabel>
            <Select
              labelId="zone-label"
              value={selectedClub}
              name="zone"
              onChange={(event) => setSelectedClub(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {clubCategory?.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 190 }} size="small">
            <InputLabel>Filter by DealerType</InputLabel>
            <Select
              // labelId="zone-label"
              value={selectedDealerType}
              name="zone"
              onChange={(event) => setSelectedDealerType(event.target.value)}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {dealerType?.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div>
          <FormControl sx={{ m: 1, minWidth: 475, mr: 4 }} size="small">
            <TextField
              onChange={handleChange}
              value={search}
              name="search"
              variant="outlined"
              label="Search Dealer Name or Dealer Code or Territory"
              inputProps={{
                style: {
                  height: "16px",
                },
              }}
              // InputLabelProps={{
              //   style: {
              //     paddingBottom: "10px",
              //   },
              // }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
        </div>
      </div>

      <div
        style={{
          margin: "1.5rem 0 2rem 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center ",
        }}
      >
        <div
          className={styles.sales_div}
          style={{
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <p>#Dealers</p>
            <p>
              {totalSums?.totalCount ? formatNumber(totalSums?.totalCount) : 0}
            </p>
          </div>
          <div>
            <p>Sales (MTD)</p>
            <p>
              {formatNumber(Math.floor(totalSums?.totalSaleValue / 100000))}
              {totalSums?.totalSaleValue > 0 ? " Lac" : null}
              <span>
                {/* {calculatePercentage(
                  Math.floor(totalSums?.totalSaleValue),
                  Math.floor(totalSums?.lastMonthSales)
                )}
                % */}
                <Button
                  startIcon={
                    isFinite(totalSums?.lastMonthSales) &&
                    calculatePercentage(
                      Math.floor(totalSums?.totalSaleValue),
                      Math.floor(totalSums?.lastMonthSales)
                    ) > 0 ? (
                      <TrendingUpIcon />
                    ) : (
                      <TrendingDownIcon />
                    )
                  }
                  style={{
                    color:
                      isFinite(totalSums?.lastMonthSales) &&
                      calculatePercentage(
                        Math.floor(totalSums?.totalSaleValue),
                        Math.floor(totalSums?.lastMonthSales)
                      ) > 0
                        ? "green"
                        : "red",
                    fontWeight: "600",
                  }}
                >
                  {calculatePercentage(
                    Math.floor(totalSums?.totalSaleValue),
                    Math.floor(totalSums?.lastMonthSales)
                  )}
                  %
                </Button>
              </span>
            </p>
          </div>
          {/* <div>
            <p>Outstanding (MTD)</p>
            <p>
              {formatNumber(
                Math.floor(totalSums?.totalOutThirty / 10000000000)
              )}
              {totalSums?.totalOutThirty > 0 ? " Lac" : null}
            </p>
          </div> */}
          <div>
            <p>Outstanding (TOT)</p>
            <p>
              {formatNumber(Math.floor(totalSums?.totalOutTotal / 100000))}
              {totalSums?.totalOutTotal > 0 || totalSums?.totalOutTotal < 0
                ? " Lac"
                : null}
            </p>
          </div>
          <div>
            <p>Overdue (AOD)</p>
            <p>
              {formatNumber(Math.floor(totalSums?.totalOverdue / 100000))}{" "}
              {totalSums?.totalOverdue > 0 || totalSums?.totalOverdue < 0
                ? " Lac"
                : null}
            </p>
          </div>
        </div>

        <Button
          variant="contained"
          //   startIcon={<CloudDownloadIcon />}
          onClick={() => setOpenModal(true)}
          disabled={compareData.length === 0 ? true : false}
          sx={{ mr: 4 }}
        >
          Compare
        </Button>
      </div>

      <div style={{ width: "98%", marginTop: "1rem", marginBottom: "2rem" }}>
        <>
          <TableContainer component={Paper} sx={{ mb: 2.5 }}>
            <Table>
              <TableHead className={styles.main_table_layout}>
                <TableRow className={styles.main_table_header}>
                  <TableCell
                    align="left"
                    sx={{ fontWeight: "bolder", color: "#AEACAA" }}
                  >
                    Compare
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                      width: "120px",
                    }}
                  >
                    Dealer Code
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bolder", color: "#AEACAA" }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bolder", color: "#AEACAA" }}
                  >
                    City
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                      // width: "120px",
                    }}
                  >
                    Dealer Type
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                    }}
                  >
                    Club
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                      width: "200px",
                    }}
                  >
                    Sales (MTD)
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                      // width: "170px",
                    }}
                  >
                    Outstanding (AOD)
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                      // width: "150px",
                    }}
                  >
                    Overdue (AOD)
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ fontWeight: "bolder", color: "#AEACAA" }}
                  >
                    SAS
                  </TableCell>
                  {/* <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bolder",
                      color: "#AEACAA",
                      // width: "100px",
                    }}
                  >
                    JK Rank
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0
                  ? data?.map((d) => (
                      <TableRow
                        key={d._id}
                        onClick={() => handleRowClick(d)}
                        className={styles.main_table_data_row}
                      >
                        {/* <TableCell align="center">
                          <button
                            // style={{
                            //   borderBottom: "1px solid grey",
                            //   padding: "2px",
                            //   borderRadius: "2px",
                            // }}
                            onClick={(e) => {
                              e.stopPropagation();
                              updateCompareList(d);
                            }}
                          >
                            {compareData?.includes(d) ? (
                              <RemoveCircleOutlineIcon
                                style={{ color: "red" }}
                              />
                            ) : (
                              <AddCircleOutlineIcon
                                style={{ color: "green" }}
                              />
                            )}
                          </button>
                        </TableCell> */}
                        <TableCell align="center">
                          <Checkbox
                            checked={compareData?.includes(d)}
                            onChange={(e) => {
                              e.stopPropagation();
                              updateCompareList(d);
                            }}
                            onClick={(e) => e.stopPropagation()}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell
                          align="left"
                          className={styles.main_table_data_row}
                        >
                          {d?.Kunnr}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {d?.Name1}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {d?.City1}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {d?.Dltype}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {d?.Class}
                        </TableCell>
                        <TableCell
                          align="left"
                          className={styles.main_table_data_row}
                        >
                          <div className={styles.tooltip}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                              }}
                            >
                              {/* <div>{parseFloat(d?.SaleVal)}</div> */}
                              <div>{formatNumber(Math.floor(d?.SaleVal))}</div>
                              <div>
                                <Button
                                  startIcon={
                                    isFinite(d?.lastMonthSales) &&
                                    calculatePercentage(
                                      parseFloat(d?.SaleVal),
                                      parseFloat(d?.lastMonthSales)
                                    ) > 0 ? (
                                      <TrendingUpIcon />
                                    ) : calculatePercentage(
                                        parseFloat(d?.SaleVal),
                                        parseFloat(d?.lastMonthSales)
                                      ) < 0 ? (
                                      <TrendingDownIcon />
                                    ) : null
                                  }
                                  style={{
                                    color:
                                      isFinite(d?.lastMonthSales) &&
                                      calculatePercentage(
                                        parseFloat(d?.SaleVal),
                                        parseFloat(d?.lastMonthSales)
                                      ) > 0
                                        ? "green"
                                        : calculatePercentage(
                                            parseFloat(d?.SaleVal),
                                            parseFloat(d?.lastMonthSales)
                                          ) < 0
                                        ? "red"
                                        : "grey",
                                    fontWeight: "600",
                                  }}
                                >
                                  {calculatePercentage(
                                    parseFloat(d?.SaleVal),
                                    parseFloat(d?.lastMonthSales)
                                  )}
                                  %
                                </Button>
                              </div>
                            </div>

                            <div className={styles.tooltiptext}>
                              {/* {d?.saleValue} */}
                              <p
                                style={{
                                  color:
                                    calculatePercentage(
                                      parseFloat(d?.SaleVal),
                                      parseFloat(d?.lastMonthSales)
                                    ) > 0
                                      ? "green"
                                      : "red",
                                }}
                              >
                                <Button
                                  startIcon={
                                    isFinite(d?.lastMonthSales) &&
                                    calculatePercentage(
                                      parseFloat(d?.SaleVal),
                                      parseFloat(d?.lastMonthSales)
                                    ) > 0 ? (
                                      <TrendingUpIcon />
                                    ) : (
                                      <TrendingDownIcon />
                                    )
                                  }
                                  style={{
                                    color:
                                      isFinite(d?.lastMonthSales) &&
                                      calculatePercentage(
                                        parseFloat(d?.SaleVal),
                                        parseFloat(d?.lastMonthSales)
                                      ) > 0
                                        ? "green"
                                        : calculatePercentage(
                                            parseFloat(d?.SaleVal),
                                            parseFloat(d?.lastMonthSales)
                                          ) < 0
                                        ? "red"
                                        : "grey",
                                    fontWeight: "600",
                                  }}
                                >
                                  {calculatePercentage(
                                    parseFloat(d?.SaleVal),
                                    parseFloat(d?.lastMonthSales)
                                  )}
                                  %
                                </Button>

                                {/* <span
                                  style={{
                                    marginLeft: "5px",
                                  }}
                                >
                                  {calculatePercentage(
                                    parseFloat(d?.SaleVal),
                                    parseFloat(d?.lastMonthSales)
                                  )}
                                  %
                                </span> */}
                              </p>
                              <p
                                style={{
                                  textDecoration: "underline",
                                  fontSize: "16px",
                                  marginBottom: "10px",
                                }}
                              >
                                {Math.floor(
                                  Math.floor(d?.SaleVal) -
                                    Math.floor(d?.lastMonthSales)
                                )}
                              </p>
                              <p
                                style={{ fontSize: "12px", color: "darkgray" }}
                              >
                                {moment.utc().startOf("month").format("DDMMM")}{" "}
                                - {moment.utc().format("DDMMM")}
                              </p>
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bolder",
                                }}
                              >
                                {formatNumber(Math.floor(d?.SaleVal))}
                              </p>
                              <p
                                style={{ fontSize: "12px", color: "darkgray" }}
                              >
                                {moment
                                  .utc()
                                  .subtract(1, "month")
                                  .startOf("month")
                                  .format("DDMMM")}{" "}
                                -{" "}
                                {moment
                                  .utc()
                                  .subtract(1, "month")
                                  .format("DDMMM")}
                              </p>
                              <p
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bolder",
                                }}
                              >
                                {formatNumber(Math.floor(d?.lastMonthSales))}
                              </p>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {/* {formatNumber(parseFloat(d?.OutTot) / 100000)} */}
                          {formatNumber(Math.floor(d?.OutTot))}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {/* {formatNumber(parseFloat(d?.OverDue))} */}
                          {formatNumber(Math.floor(d?.OverDue))}
                        </TableCell>
                        <TableCell
                          align="center"
                          className={styles.main_table_data_row}
                        >
                          {formatNumber(Math.floor(d?.SasOut))}
                        </TableCell>
                        {/* <TableCell align="center">##</TableCell> */}
                      </TableRow>
                    ))
                  : null}
              </TableBody>
            </Table>
            <Grid justifyContent={"center"} container p={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
              />
            </Grid>
          </TableContainer>
        </>
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box sx={messageStyle}>
          {compareData && compareData.length > 0 ? (
            <>
              <h3 style={{ textAlign: "center" }}>Dealer Comparison</h3>
              {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                {compareData?.map((item, index) => {
                  return (
                    <div
                      style={{
                        borderRight:
                          index < compareData?.length - 1
                            ? "1px dotted #ccc"
                            : "none",
                        paddingRight: "20px",
                        width: `${100 / compareData.length}%`,
                        textAlign: "center",
                        // border: "1px solid red",
                        marginTop: "2rem",
                      }}
                      key={item._id}
                    >
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "50%",
                          backgroundColor: "darkgray",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginLeft: "48%",
                        }}
                      >
                        {item.name.slice(0, 1)}
                      </div>
                      <div>
                        <p style={{ marginTop: "1rem" }}>{item.name}</p>
                      </div>
                      <table>
                        <tr>
                          <th style={{ textAlign: "right" }}>JK Rank</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            ##
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>City</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.city}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>Dealer Type</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.dealerType1}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>Club</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.clubCategory}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>Sale - MTD</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.saleValue}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>
                            Outstanding - AOD
                          </th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.outTotal}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>Overdue - AOD</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.overdue}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>SAS</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {item?.sasIn}
                          </td>
                        </tr>
                        <tr>
                          <th style={{ textAlign: "right" }}>Sale Tyre Cat</th>
                          <td
                            style={{ textAlign: "left", paddingLeft: "1rem" }}
                          >
                            {"NA"}
                          </td>
                        </tr>
                      </table>
                      <Button variant="contained">View profile</Button>
                    </div>
                  );
                })}
              </div> */}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {[...Array(3)].map((_, index) => {
                  const item = compareData[index];
                  return (
                    <div
                      key={index}
                      style={{
                        borderRight: index < 2 ? "3px dotted #ccc" : "none",
                        paddingRight: "20px",
                        width: `${99 / 3}%`,
                        textAlign: "center",
                        marginTop: "2rem",
                      }}
                    >
                      {item && (
                        <>
                          <div
                            style={{
                              width: "70px",
                              height: "80px",
                              borderRadius: "50%",
                              backgroundColor: "darkgray",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              marginLeft: "40%",
                            }}
                          >
                            {item.Name1.slice(0, 1)}
                          </div>
                          <table className={styles.compare_modal_table}>
                            <tr>
                              <th style={{ textAlign: "right" }}>Name</th>
                              <td>{item?.Name1}</td>
                            </tr>
                            {/* <tr>
                              <th style={{ textAlign: "right" }}>JK Rank</th>
                              <td>##</td>
                            </tr> */}
                            <tr>
                              <th style={{ textAlign: "right" }}>City</th>
                              <td>{item?.City1}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>
                                Dealer Type
                              </th>
                              <td>{item?.DlType}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>Club</th>
                              <td>{item?.Class}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>Sale - MTD</th>
                              <td>{item?.SaleVal}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>
                                Outstanding(AOD)
                              </th>
                              <td>{item?.OutTot}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>
                                Overdue(AOD)
                              </th>
                              <td>{item?.OverDue}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>SAS</th>
                              <td>{item?.SasIn}</td>
                            </tr>
                            <tr>
                              <th style={{ textAlign: "right" }}>
                                Sale Tyre Cat
                              </th>
                              <td>{"NA"}</td>
                            </tr>
                          </table>
                          <Button
                            variant="contained"
                            style={{ marginTop: "2rem", marginBottom: "2rem" }}
                            onClick={() => handleRowClick(item)}
                          >
                            View profile
                          </Button>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <h6>Select dealer's first to compare.</h6>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default DealerDirectoryList;
